module.exports = "<section>\n  <h2 class=\"underlined-title\">\n    Confirm account\n  </h2>\n\n  <p class=\"confirmation-form__tnx\" ng-if=\"!$ctrl.confirmed && !$ctrl.errors.length\">\n    Confirmation...\n  </p>\n\n  <p class=\"confirmation-form__tnx\" ng-if=\"$ctrl.confirmed\">\n    Your account was successfully confirmed.\n  </p>\n\n  <p class=\"confirmation-form__error\" ng-repeat=\"error in $ctrl.errors\">\n    {{error}}\n  </p>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/guest/screens/confirmation/confirmation.html
// module id = 363
// module chunks = 0